import { Localita } from "./portale/localita"

export class DatiOperaDTO {
	descrizione: string;
	regione: Localita;
}
